import { PromotionsStylesSchema } from './Promotions.styles';

export const promotionsStyles: PromotionsStylesSchema = {
  heading: {
    mb: '2',
    color: 'white',
    fontWeight: '700',
  },
  promotionWrapper: {
    p: '4',
    bgGradient: 'linear(to-b, beta.600, beta.700)',
    my: '3',
    boxShadow: 'lg',
    borderRadius: 'md',
  },
  flexWrapper: { gap: '4', pt: '4', justifyContent: 'space-between' },
  termsAndConditions: { color: 'white', fontSize: 'sm', pt: '1' },
};
